/**
 * 「AI エージェントをつなぐ」の画面（今は使い方ガイド /guide の始め方 1。もとは /connect・pages/ConnectPage.tsx）の置き場所（2026-10-07 console/connect-again）。
 *
 * WHY 別の画面にするか: 以前はコピペの 1 行（homeFlow.ts connectAsk・HomeParts.tsx ConnectBody）がホームの「つなぐ」の段にしか無く、
 *   その段は未接続のあいだだけ出る（homeFlow.ts homeStepsC: プロジェクトがある人は済んだ段を消す）。つないだ後は
 *   どこからも見られなかった。founder（2026-10-07）「スターター用のプロンプト、何度でもみたいがどこにあるかわからない。
 *   環境を変えて使う人もいる」→ 新しい PC・別の AI エージェント・クラウドのセッションで使い始めるときのために、
 *   トップバー（どの画面からも 1 クリック）から開ける画面に同じ ConnectBody を出す。1 行の中身は変えない（ConnectBody のまま。2026-10-11 console/one-connect からは、どの AI にも貼る 1 つの文 = webConnect.ts connectPromptFor）。
 * パスは cliDevice.ts の CLI_DEVICE_PATH と同じく定数 1 か所（App.tsx のルート・トップバー・ホーム・概要のリンクがここを見る）。
 */
// 2026-10-07 founder「これは使用法に入れればよいよね」→ 1 行は使い方ガイド（/guide）の始め方 1 に直接出す。
//   リンクはすべてガイドへ。/connect は前に配った URL のためにガイドへ移すだけ（App.tsx の Navigate）。
export const CONNECT_PATH = '/guide';
export const OLD_CONNECT_PATH = '/connect';
